import { SITE_URL } from '../resolveSEO';
import type { ArticleData } from '../types';

interface Input {
  url: string;
  articleData?: ArticleData;
}

export const buildArticle = ({ url, articleData }: Input) => {
  if (!articleData) return null;
  return {
    '@type': 'Article',
    '@id': `${url}#article`,
    headline: articleData.headline,
    description: articleData.description,
    image: {
      '@type': 'ImageObject',
      url: articleData.image,
    },
    datePublished: articleData.datePublished,
    ...(articleData.dateModified && {
      dateModified: articleData.dateModified,
    }),
    author: {
      '@type': 'Person',
      name: articleData.author.name,
      ...(articleData.author.email && { email: articleData.author.email }),
    },
    publisher: {
      '@id': `${SITE_URL}/#organization`,
    },
    mainEntityOfPage: {
      '@id': `${url}#webpage`,
    },
  };
};
